<div v-if="enableCutouts" class="matrix_optionsTable matrix_table" id="cutouts_container">
  <div class="matrix_tableHeader">{{ $t("Cutouts") }}</div>

  <div class="sidebar_popup">
    <div class="cutouts_toolbar">
      <div class="cutouts_button" @click="addNewCutout('rectangle')">
        <span>{{$t('Add Rectangle') }}</span>
      </div>
      <div class="cutouts_button" @click="addNewCutout('circle')">
        <span> {{$t('Add Circle') }}</span>
      </div>
    </div>
    <ul class="dimensions-list" v-show="total">
      <li
        v-for="(cutout, index) in getCutouts.cutouts"
        class="newcutout_item"
        :id="'cutout-item-' + index"
      >
        <span class="number">{{index + 1}}</span>
        <div :class="'cutout cutout_'+ cutout.itemType"></div>
        <div class="posxy">
          <div class="pos_input">
            <label :for="'cutoutX-' + index">{{$t('X:') }}</label>
            <input
              v-model.number="cutout.left"
              :id="'cutoutX-' + index"
              type="number"
              min="0"
              step="0.1"
              :value.number="cutout.left"
               v-on:keydown.enter="onEnter"
              class="cutout_input"
            />
            <span class="cm">{{$t('cm') }}</span>
          </div>
          <div class="pos_input">
            <label :for="'cutoutY-' + index">{{$t('Y:') }}</label>
            <input
              v-model.number="cutout.bottom"
              :id="'cutoutY-' + index"
              type="number"
              min="0"
              step="0.1"
               v-on:keydown.enter="onEnter"
              :value.number="cutout.bottom"
              class="cutout_input"
            />
            <span class="cm">{{$t('cm') }}</span>
          </div>
          <div class="pos_input">
            <label :for="'width-' + index">{{$t('Width:')}}</label>
            <input
              v-model.number="cutout.width"
              :id="'width-' + index"
              type="number"
               v-on:keydown.enter="onEnter"
              min="0"
              step="0.1"
              :value.number="cutout.width"
              class="cutout_input"
            />
            <span class="cm">{{$t('cm') }}</span>
          </div>
          <div class="pos_input">
            <label :for="'height-' + index">{{$t('Height:') }}</label>
            <input
              v-model.number="cutout.height"
              :id="'height-' + index"
              type="number"
              min="0"
              step="0.1"
               v-on:keydown.enter="onEnter"
              :value.number="cutout.height"
              class="cutout_input"
            />
            <span class="cm">{{$t('cm')}}</span>
          </div>
        </div>
        <div @click="removeCutout(index)" class="delete-dosen">
          <appAwesomeIcon icon="trash-alt" useClass="fa fa-trash-o" />
        </div>
      </li>
    </ul>
  </div>
</div>
